module.exports = __webpack_public_path__ + "img/1525597398.20ce40df.jpg";